import React, {
  useEffect,
  useCallback,
  useState,
  useRef,
} from 'react';
import { CenteredLoader } from '@playbookux/playbook-web-core';
import { useHistory } from 'react-router-dom';
import {
  arrayOf, bool, func, shape, string,
} from 'prop-types';
import VideoPlayer, { withMedia } from '..';
import { useQueryString } from '../../../hooks/use-query-string';
import ControlBarSpacer from '../control-bar-spacer';

const PlaylistPlayerHud = (props) => {
  const {
    url, autoplay, videos, media, markers,
  } = props;
  const history = useHistory();
  const query = useQueryString();
  const videoId = query.get('videoId');

  const videoIndex = useRef(0);
  const [currentVideo, setCurrentVideo] = useState(null);

  const { seekTo } = media;

  useEffect(() => {
    if (seekTo) {
      seekTo(currentVideo.answer.videoStartTime);
    }
  }, [currentVideo, seekTo]);

  const updateVideoIndex = useCallback((index) => {
    videoIndex.current = index;
    setCurrentVideo(videos[index]);
  }, [videos]);

  const handleChangeVideo = useCallback((id) => {
    history.push(`${url}?videoId=${id}`);
  }, [history, url]);

  const handleVideoEnded = useCallback(() => {
    const nextIndex = (videoIndex.current + 1) % videos.length;
    handleChangeVideo(videos[nextIndex].videoId);
  }, [handleChangeVideo, videos]);

  // Change video if videoId is not in the list
  useEffect(() => {
    if (autoplay && !videoId && videos.length > 0) {
      updateVideoIndex(0);
      handleChangeVideo(videos[0].videoId);
    }
  }, [autoplay, videoId, handleChangeVideo, updateVideoIndex, videos]);

  // Change video if videoId is in the list
  useEffect(() => {
    if (videoId) {
      const index = videos.findIndex((video) => video.videoId === videoId);
      if (index !== -1) {
        updateVideoIndex(index);
      }
    }
  }, [videoId, updateVideoIndex, videos]);

  return (
    <>
      {currentVideo?.videoUrl ? (
        <VideoPlayer
          src={currentVideo.videoUrl}
          autoplay={autoplay}
          onEnded={handleVideoEnded}
          markers={markers}
        >
          <ControlBarSpacer
            beforeElement="downloadButton"
          />
        </VideoPlayer>
      ) : <CenteredLoader data-loader="transcripts-video-loader" />}
    </>
  );
};

PlaylistPlayerHud.propTypes = {
  url: string.isRequired,
  autoplay: bool,
  videos: arrayOf(shape({
    videoId: string.isRequired,
    videoUrl: string.isRequired,
  })).isRequired,
  media: shape({
    seekTo: func,
  }).isRequired,
  markers: arrayOf({}),
};

PlaylistPlayerHud.defaultProps = {
  autoplay: false,
  markers: [{}],
};

export default withMedia(PlaylistPlayerHud);
